import { useMedia } from '@/hooks/useMedia/useMedia';
import { Box, LinearProgress, Typography } from '@mui/material';
import { FC } from 'react';

type Props = {
    value?: {
        score: number;
        total: number;
    };
};

export const StudentProgress: FC<Props> = ({ value }) => {
    const { isMobile } = useMedia();

    return (
        <Box
            sx={(theme) => ({
                px: 1,
                display: 'flex',
                borderRadius: 0.5,
                gap: 1,
                flexDirection: 'row',
                alignItems: 'center',
                backgroundColor: `color-mix(in srgb, ${(theme.vars || theme).palette.grey[200]}, transparent 60%)`,
                ...theme.applyStyles('dark', {
                    backgroundColor: `color-mix(in srgb, ${(theme.vars || theme).palette.grey[900]}, transparent 60%)`,
                }),
            })}
        >
            <LinearProgress variant='determinate' color='primary' value={value ? (value.score / value.total) * 100 : 0} sx={{ flex: 1 }} />
            {value && (
                <Typography variant='caption' fontSize={isMobile ? 10 : 12}>
                    {value.score}/{value.total}
                </Typography>
            )}
        </Box>
    );
};
